/**
 * Opciones de captura de Proveedores de Cirugia.
 *
 * Las opciones viven en el catalogo (`cat_surgery_providers.option_key`) como proveedores
 * fijos, para que elegirlas deje un registro visible en la tabla del caso. De ahi vienen su
 * nombre y su orden; aqui solo esta el comportamiento que el front necesita saber de cada una.
 *
 * - `requires`: estatus que implica el registro (lo recalcula el backend a partir de la tabla).
 * - `createsRow`: false en NO USO PROVEEDOR DE RED, que no deja renglon propio sino que abre
 *   la captura del nombre del proveedor fuera de red.
 */
export const SURGERY_PROVIDER_OPTION_BEHAVIORS = Object.freeze({
  NO_APLICA_ESPECIALIDAD: { requires: "No", createsRow: true },
  NO_REQUIRIO_INSUMOS: { requires: "No", createsRow: true },
  NO_USO_PROVEEDOR_RED: { requires: "Si", createsRow: false },
});

/** Devuelve el comportamiento de la opcion, o null si la entrada es un proveedor real. */
export const optionBehavior = (optionKey) =>
  (optionKey && SURGERY_PROVIDER_OPTION_BEHAVIORS[optionKey]) || null;

export const SURGERY_PROVIDERS_NOTE =
  "NOTA: SELECCIONA UNO O MAS PROVEEDORES QUE HAYAN PARTICIPADO DENTRO DE LA CIRUGIA DEL " +
  "ASEGURADO (PROPORCIONADO INSUMOS). FAVOR DE AGREGAR SOLO LOS PROVEEDORES QUE HAYAN " +
  "INTERVENIDO EN PROCEDIMIENTOS DE CARDIOLOGIA Y ORTOPEDIA.";
